<template>
    <div class="contact">
        <div class="square square--1"><div class="gradient"/></div>
        <div class="square square--2"><div class="gradient"/></div>
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-5 mb-5 text-center text-lg-start">
                    <h1 class="f48 fw700 mb-5">Chcesz wyposażyć <br class="d-none d-xl-block">swój biznes <span
                        class="d-xl-block light-blue">w&nbsp;PayTel LightPOS?</span></h1>
                    <p class="f20 mb-5 blue">Wypełnij formularz kontaktowy - <b>skontaktujemy się z&nbsp;Tobą w&nbsp;celu
                        przedstawienia oferty!</b></p>
                    <div class="row d-none d-lg-flex">
                        <div class="col-6 col-xl-5 text-center">
                            <img src="@/assets/img/app-1.png" :srcset="`${require('@/assets/img/app-1@2x.png')} 2x`"
                                 alt="" class="app-img img-fluid">
                        </div>
                        <div class="col-6 col-xl-5 text-center">
                            <img src="@/assets/img/app-2.png" :srcset="`${require('@/assets/img/app-2@2x.png')} 2x`"
                                 alt="" class="app-img img-fluid">
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 offset-lg-1">
                    <div class="row">
                        <div class="col-12 mb-3 text-center text-lg-start">
                            <p class="f26 fw700">FORMULARZ KONTAKTOWY</p>
                        </div>
                        <div class="col-12">
                            <p class="f16 fw700 mb-3">Jesteś już klientem PayTel?</p>
                        </div>
                        <div class="col-12 mb-3">

                            <div class="check d-inline-block fw700">
                                <input type="radio" id="r1" v-model="form.client" value="yes">
                                <label for="r1">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18.41" height="13.885" viewBox="0 0 18.41 13.885">
                        <path id="Union_1" data-name="Union 1"
                              d="M-12635.786,18.006l-6.507-6.508a1,1,0,0,1,0-1.415l1.979-1.98a1,1,0,0,1,1.415,0l3.82,3.82,7.215-7.215a1,1,0,0,1,1.415,0l1.98,1.98a1,1,0,0,1,0,1.415l-9.9,9.9a1,1,0,0,1-.707.293A1,1,0,0,1-12635.786,18.006Z"
                              transform="translate(12642.586 -4.413)" fill="#11447c"/>
                      </svg>
                    </span>
                                    Tak
                                </label>
                            </div>
                            <div class="check d-inline-block fw700 ms-4">
                                <input type="radio" id="r2" v-model="form.client" value="no">
                                <label for="r2">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18.41" height="13.885" viewBox="0 0 18.41 13.885">
                        <path id="Union_1" data-name="Union 1"
                              d="M-12635.786,18.006l-6.507-6.508a1,1,0,0,1,0-1.415l1.979-1.98a1,1,0,0,1,1.415,0l3.82,3.82,7.215-7.215a1,1,0,0,1,1.415,0l1.98,1.98a1,1,0,0,1,0,1.415l-9.9,9.9a1,1,0,0,1-.707.293A1,1,0,0,1-12635.786,18.006Z"
                              transform="translate(12642.586 -4.413)" fill="#11447c"/>
                      </svg>
                    </span>
                                    Nie
                                </label>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="input">
                                <label for="">IMIĘ</label>
                                <input type="text" v-model="form.first_name">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="input">
                                <label for="">NAZWISKO</label>
                                <input type="text" v-model="form.last_name">
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input">
                                <label for="">E-MAIL</label>
                                <input type="text" v-model="form.email">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="input">
                                <label for="">NIP</label>
                                <input type="text" v-mask="'###-##-##-###'" v-model="form.nip">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="input">
                                <label for="">Numer Telefonu</label>
                                <input type="text" v-mask="'+48 ### ### ###'" v-model="form.phone">
                            </div>
                        </div>
                        <div class="col-12 mt-4">
                            <div class="check">
                                <input type="checkbox" id="ch1" v-model="form.agreement_1">
                                <label for="ch1">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18.41" height="13.885" viewBox="0 0 18.41 13.885">
                        <path id="Union_1" data-name="Union 1"
                              d="M-12635.786,18.006l-6.507-6.508a1,1,0,0,1,0-1.415l1.979-1.98a1,1,0,0,1,1.415,0l3.82,3.82,7.215-7.215a1,1,0,0,1,1.415,0l1.98,1.98a1,1,0,0,1,0,1.415l-9.9,9.9a1,1,0,0,1-.707.293A1,1,0,0,1-12635.786,18.006Z"
                              transform="translate(12642.586 -4.413)" fill="#11447c"/>
                      </svg>
                    </span>
                                    Wyrażam zgodę na przetwarzanie moich danych osobowych przez PayTel S.A. z&nbsp;siedzibą
                                    przy ulicy Żwirki i&nbsp;Wigury 14, 02-092 Warszawa w&nbsp;celu przedstawienia
                                    oferty przez PayTel.</label>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="check">
                                <input type="checkbox" id="ch2" v-model="form.agreement_2">
                                <label for="ch2">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18.41" height="13.885" viewBox="0 0 18.41 13.885">
                        <path id="Union_1" data-name="Union 1"
                              d="M-12635.786,18.006l-6.507-6.508a1,1,0,0,1,0-1.415l1.979-1.98a1,1,0,0,1,1.415,0l3.82,3.82,7.215-7.215a1,1,0,0,1,1.415,0l1.98,1.98a1,1,0,0,1,0,1.415l-9.9,9.9a1,1,0,0,1-.707.293A1,1,0,0,1-12635.786,18.006Z"
                              transform="translate(12642.586 -4.413)" fill="#11447c"/>
                      </svg>
                    </span>
                                    Wyrażam zgodę na kontaktowanie się ze mną na udostępniony przeze mnie adres poczty
                                    elektronicznej lub numer telefonu w&nbsp;celu przedstawienia oferty przez
                                    PayTel.</label>
                            </div>
                        </div>
                        <div class="col-12">
                            <p class="f14">Administratorem danych osobowych jest PayTel S.A. z&nbsp;siedzibą w&nbsp;Warszawie
                                (02-092) przy ul. Żwirki i&nbsp;Wigury 14.
                                Poniższe zgody udzielane są jednorazowo. Więcej informacji na temat przetwarzania danych
                                osobowych znajduje się sekcji
                                <a target="_blank"
                                   href="https://www.paytel.pl/wp-content/uploads/2022/09/ochrona_danych_osobowych_paytel_sa.pdf"
                                   class="text-decoration-underline fw700 blue">Ochrona Danych Osobowych</a> - prosimy o&nbsp;zapoznanie
                                się z&nbsp;umieszczonymi tam treściami.</p>
                        </div>
                        <div class="col-12 mt-3 text-center">
                            <button class="btn btn--main" @click.prevent="sendForm()" :disabled="loader">WYŚLIJ
                                WIADOMOŚĆ
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <message-component v-if="message.show" :content="message.content" :type="message.type"
                           @close="message={show:false,type:'',content:[]}"/>
    </div>
</template>

<script>
import {default as axios} from "axios";
import MessageComponent from "@/components/MessageComponent";

export default {
    name: 'ContactSection',
    components: {MessageComponent},
    data() {
        return {
            loader: false,
            message: {
                show: false,
                type: '',
                content: [],
            },
            form: {
                first_name: '',
                last_name: '',
                email: '',
                nip: '',
                phone: '',
                agreement_1: false,
                agreement_2: false,
                client: false,
            }
        }
    },
    methods: {
        sendForm() {
            this.loader = true
            axios.post('api/contact/message', this.form)
                .then(() => {
                    this.message = {
                        show: true,
                        type: 'ok',
                        content: {message: ['Wiadomość została wysłana.']},
                    }
                })
                .catch((error) => {
                    this.message = {
                        show: true,
                        type: 'err',
                        content: error.response.data.errors,
                    }
                })
                .then(() => {
                    this.loader = false;
                })
        }
    }
}
</script>

<style scoped lang="scss">
.contact {
    margin-bottom: 100px;
    position: relative;
    z-index: 10;
}

.app-img {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 0 0 4px #D9D9D9, 20px 13px 26px 0 rgba(0, 0, 0, .1);
}
.square {
    .gradient {
        width: 100%;
        border-radius: 10%;
        position: relative;
        &::after {
            content: '';
            display: block;
            padding-bottom: 100%;
        }
    }
    &--1 {
        width: 30%;
        transform: translate(-60%, 0) rotate(45deg);
        position: absolute;
        top: 20%;
        left: 0;
        z-index: -1;
        pointer-events: none;
        .gradient {
            background: #E2F5FD;
        }
    }
    &--2 {
        width: 30%;
        transform: translate(-70%, -100%) rotate(45deg);
        position: absolute;
        top: 0;
        left: 100%;
        z-index: -1;
        pointer-events: none;
        .gradient {
            background: #FAFAFA;
        }
    }
}
</style>

